angular.module('impactx.pushmessage').controller('PushMessageLoginCtrl', [
    '$scope',
    'dataGen',
    '$mdDialog',
    'messages',
    'trns',
    PushMessageLoginCtrl
]);

function PushMessageLoginCtrl($scope, dataGen, $mdDialog, messages, trns) {
    var self = this;
    $scope.index = 0;
    $scope.messages = messages;
    $scope.trns = trns;
    $scope.currentMessage = $scope.messages[$scope.index];

    this.save = function () {
        var dataObj = {
            dtos: $scope.messages
        };
        dataGen.postAsForm($scope, dataObj, "/pushmessage/login/save");
        $mdDialog.hide(); // Always hide
    };

    this.next = function()
    {
        $scope.index++;
        $scope.currentMessage = $scope.messages[$scope.index];
    }

    this.hasNext = function()
    {
        return $scope.messages && ($scope.index < $scope.messages.length - 1);
    }

    this.back = function()
    {
        $scope.index--;
        $scope.currentMessage = $scope.messages[$scope.index];
    }

    this.hasBack = function()
    {
        return $scope.messages && $scope.index > 0;
    }
}